export const crudeDatabase = {
  BONNY_LIGHT: {
    name: "Bonny Light Crude Oil",
    country: "Nigeria",
    type: "Light Sweet",

    /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
    bulkElementalComposition: {
      1: {
        name: "Carbon, C",
        value: 86.0,
        unit: "wt%"
      },

      2: {
        name: "Hydrogen, H",
        value: 13.4,
        unit: "wt%"
      },

      3: {
        name: "Sulfur, S",
        value: "0.14–0.16",
        unit: "wt%"
      },

      4: {
        name: "Nitrogen, N",
        value: 0.098,
        secondaryValue: 1170,
        unit: "wt%",
        secondaryUnit: "ppm"
      },

      5: {
        name: "Oxygen, O",
        value: 0.2,
        unit: "wt%"
      },

      6: {
        name: "H/C Ratio",
        value: 1.86,
        unit: ""
      }
    },

    /* ================= B. PHYSICAL PROPERTIES ================= */
    physicalProperties: {

      7: {
        name: "API Gravity @ 60°F",
        value: "32.9–35.09",
        unit: "°API"
      },

      8: {
        name: "Specific Gravity @ 60/60°F",
        value: 0.86,
        unit: ""
      },

      9: {
        name: "Density @ 15°C",
        value: 849.0,
        unit: "kg/m³"
      },

      10: {
        name: "Viscosity @ 20°C",
        value: 8.54,
        unit: "cSt"
      },

      11: {
        name: "Viscosity @ 40°C",
        value: 4.99,
        unit: "cSt"
      },

      12: {
        name: "Viscosity @ 50°C",
        value: "2.9–4.05",
        unit: "cSt"
      },

      13: {
        name: "Viscosity @ 100°C",
        value: 1.5,
        unit: "cSt"
      },

      14: {
        name: "Pour Point",
        value: "-14.4",
        unit: "°C"
      },

      15: {
        name: "Cloud Point",
        value: -30,
        unit: "°C"
      },

      16: {
        name: "Flash Point",
        value: "<21",
        unit: "°C"
      },

      17: {
        name: "Fire Point",
        value: 30,
        unit: "°C"
      },

      18: {
        name: "Reid Vapor Pressure (RVP)",
        value: 24.8,
        unit: "kPa"
      },

      19: {
        name: "Salt Content",
        value: "<10",
        unit: "PTB"
      },

      20: {
        name: "Water Content",
        value: "<0.1",
        unit: "vol%"
      },

      21: {
        name: "Sediment Content",
        value: "<0.01",
        unit: "wt%"
      },

      22: {
        name: "BS&W",
        value: "<0.1",
        unit: "vol%"
      },

      23: {
        name: "Ash Content",
        value: 0.01,
        unit: "wt%"
      }
    },

    /* ================= C. CORROSION & STABILITY ================= */
    corrosionStability: {

      24: {
        name: "Total Acid Number (TAN)",
        value: "0.17",
        unit: "mg KOH/g"
      },

      25: {
        name: "Strong Acid Number (SAN)",
        value: "<0.01",
        unit: "mg KOH/g"
      },

      26: {
        name: "Mercaptan Sulfur (RSH)",
        value: 2,
        unit: "mg/kg"
      },

      27: {
        name: "H₂S in Liquid",
        value: 1,
        unit: "mg/kg"
      },

      28: {
        name: "H₂S Vapor Space",
        value: "<10",
        unit: "ppm"
      },

      29: {
        name: "Organic Chlorides",
        value: "<1",
        unit: "ppm"
      },

      30: {
        name: "Inorganic Chlorides (NaCl)",
        value: "Trace",
        unit: "mg/kg"
      }
    },

    /* ================= D. TRACE METALS ================= */
    traceMetals: {

      31: {
        name: "Nickel (Ni)",
        value: "4.16",
        unit: "ppm"
      },

      32: {
        name: "Vanadium (V)",
        value: "0.42",
        unit: "ppm"
      },

      33: {
        name: "Iron (Fe)",
        value: "3",
        unit: "ppm"
      },

      34: {
        name: "Sodium (Na)",
        value: "5",
        unit: "ppm"
      },

      35: {
        name: "Calcium (Ca)",
        value: "<5",
        unit: "ppm"
      },

      36: {
        name: "Magnesium (Mg)",
        value: "<1",
        unit: "ppm"
      },

      37: {
        name: "Copper (Cu)",
        value: "<0.5",
        unit: "ppm"
      },

      38: {
        name: "Lead (Pb)",
        value: "<0.5",
        unit: "ppm"
      },

      39: {
        name: "Zinc (Zn)",
        value: "<1",
        unit: "ppm"
      },

      40: {
        name: "Silicon (Si)",
        value: "<2",
        unit: "ppm"
      },

      41: {
        name: "Phosphorus (P)",
        value: "<1",
        unit: "ppm"
      },

      42: {
        name: "Arsenic (As)",
        value: "<10",
        unit: "ppb"
      },

      43: {
        name: "Mercury (Hg)",
        value: "<5",
        unit: "ppb"
      },

      44: {
        name: "Selenium (Se)",
        value: "<10",
        unit: "ppb"
      }
    },

    /* ================= E. SARA ANALYSIS ================= */
    saraAnalysis: {

      45: {
        name: "Saturates",
        value: 65,
        unit: "wt%"
      },

      46: {
        name: "Aromatics",
        value: 25,
        unit: "wt%"
      },

      47: {
        name: "Resins",
        value: 9,
        unit: "wt%"
      },

      48: {
        name: "Asphaltenes (nC7)",
        value: "0.0032–0.2",
        unit: "wt%"
      },

      49: {
        name: "Asphaltenes (nC5)",
        value: 0.5,
        unit: "wt%"
      },

      50: {
        name: "Wax Content",
        value: 15.13,
        unit: "wt%"
      }
    },

    /* ================= F. LIGHT ENDS ================= */
    lightEnds: {

      51: {
        name: "Methane (C1)",
        value: 0.02,
        unit: "wt%"
      },

      52: {
        name: "Ethane (C2)",
        value: 0.02,
        unit: "wt%"
      },

      53: {
        name: "Propane (C3)",
        value: 0.21,
        unit: "wt%"
      },

      54: {
        name: "i-Butane",
        value: 0.28,
        unit: "wt%"
      },

      55: {
        name: "n-Butane",
        value: 0.61,
        unit: "wt%"
      },

      56: {
        name: "i-Pentane",
        value: 1.0,
        unit: "wt%"
      },

      57: {
        name: "n-Pentane",
        value: 1.2,
        unit: "wt%"
      },

      58: {
        name: "Cyclopentane",
        value: 0.2,
        unit: "wt%"
      },

      59: {
        name: "C6 Hydrocarbons",
        value: 3.5,
        unit: "wt%"
      },

      60: {
        name: "C7 Hydrocarbons",
        value: 4.0,
        unit: "wt%"
      },

      61: {
        name: "C8 Hydrocarbons",
        value: 4.5,
        unit: "wt%"
      },

      62: {
        name: "C9 Hydrocarbons",
        value: 4.0,
        unit: "wt%"
      },

      63: {
        name: "C10 Hydrocarbons",
        value: 3.5,
        unit: "wt%"
      },

      64: {
        name: "Benzene",
        value: 0.2,
        unit: "vol%"
      },

      65: {
        name: "Toluene",
        value: 0.6,
        unit: "wt%"
      },

      66: {
        name: "Ethylbenzene",
        value: 150,
        unit: "ppm"
      },

      67: {
        name: "Xylenes",
        value: 0.4,
        unit: "wt%"
      },

      68: {
        name: "CO₂",
        value: "<0.1",
        unit: "wt%"
      },

      69: {
        name: "N₂",
        value: "<0.05",
        unit: "wt%"
      }
    },

    /* ================= G. TBP DISTILLATION ================= */
    tbpDistillation: {

      70: {
        name: "IBP",
        value: 15,
        unit: "°C"
      },

      71: {
        name: "5% Recovered",
        value: 50,
        unit: "°C"
      },

      72: {
        name: "10% Recovered",
        value: 80,
        secondaryValue: 9.26,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      73: {
        name: "20% Recovered",
        value: 150,
        secondaryValue: 23.80,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      74: {
        name: "30% Recovered",
        value: 175,
        secondaryValue: 28.67,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      75: {
        name: "40% Recovered",
        value: 230,
        secondaryValue: 39.65,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      76: {
        name: "50% Recovered",
        value: 280,
        unit: "°C"
      },

      77: {
        name: "60% Recovered",
        value: 325,
        secondaryValue: 64.37,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      78: {
        name: "70% Recovered",
        value: 350,
        secondaryValue: 69.63,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      79: {
        name: "80% Recovered",
        value: 375,
        secondaryValue: 74.30,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      80: {
        name: "90% Recovered",
        value: 550,
        secondaryValue: 93.68,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      81: {
        name: "95% Recovered",
        value: 565,
        secondaryValue: 95.39,
        unit: "°C",
        secondaryUnit: "vol%"
      },

      82: {
        name: "FBP",
        value: ">565",
        unit: "°C"
      },

      83: {
        name: "% Recovered @ 360°C",
        value: 72,
        unit: "vol%"
      },

      84: {
        name: "% Recovered @ 540°C",
        value: 92,
        unit: "vol%"
      }
    },

    /* ================= H. CUT YIELDS ================= */
    cutYields: {

      LPG: {
        name: "LPG",
        yieldWt: {
          value: 1.39,
          unit: "wt%"
        },

        yieldVol: {
          value: 2.11,
          unit: "vol%"
        }
      },

      LightNaphtha: {
        name: "Light Naphtha",

        yieldWt: {
          value: 4.99,
          unit: "wt%"
        },

        yieldVol: {
          value: 6.26,
          unit: "vol%"
        },

        density: {
          value: 653,
          unit: "kg/m³"
        },

        RON: {
          value: 77.3,
          unit: ""
        }
      },

      HeavyNaphtha: {
        name: "Heavy Naphtha",

        yieldWt: {
          value: 17.56,
          unit: "wt%"
        },

        yieldVol: {
          value: 19.41,
          unit: "vol%"
        },

        density: {
          value: 768,
          unit: "kg/m³"
        }
      },

      Kerosene: {
        name: "Kerosene",

        yieldWt: {
          value: 15.23,
          unit: "wt%"
        },

        yieldVol: {
          value: 15.86,
          unit: "vol%"
        },

        smokePoint: {
          value: 21,
          unit: "mm"
        }
      },

      Diesel: {
        name: "Diesel",

        yieldWt: {
          value: 34.5,
          unit: "wt%"
        },

        yieldVol: {
          value: 33.72,
          unit: "vol%"
        },

        cetane: {
          value: 46.6,
          unit: ""
        }
      },

      VGO: {
        name: "VGO",

        yieldWt: {
          value: 21.32,
          unit: "wt%"
        },

        yieldVol: {
          value: 19.54,
          unit: "vol%"
        }
      },

      Residue: {
        name: "Residue",

        yieldWt: {
          value: 9.81,
          unit: "wt%"
        },

        yieldVol: {
          value: 8.33,
          unit: "vol%"
        }
      }
    },

    /* ================= RESIDUE PROPERTIES ================= */
    residueProperties: {

      99: {
        name: "CCR",
        value: 1.4,
        unit: "wt%"
      },

      100: {
        name: "MCR",
        value: "varies",
        unit: ""
      },

      101: {
        name: "Ramsbottom Carbon",
        value: "low",
        unit: ""
      },

      102: {
        name: "Asphaltene Stability",
        value: ">5",
        unit: ""
      },

      103: {
        name: "Heptane Insolubles",
        value: 0.2,
        unit: "wt%"
      },

      104: {
        name: "Toluene Insolubles",
        value: "<0.05",
        unit: "wt%"
      },

      105: {
        name: "UOP K Factor",
        value: "11.68–11.8",
        unit: ""
      },

      106: {
        name: "Characterization Factor",
        value: 11.8,
        unit: ""
      }
    },

    /* ================= KEY NOTES ================= */
    keyPoints: [
      "Light Sweet crude (API 33–35)",
      "Low sulfur (0.14–0.16 wt%)",
      "Very low metals",
      "High diesel yield (~34%)",
      "High wax content (~15%)",
      "Low TAN (0.17–0.25)",
      "Premium refinery feedstock"
    ]
  },





  QUA_IBOE: {
    name: "Qua Iboe Crude Oil",
    country: "Nigeria",
    type: "Light Sweet",

    /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
    bulkElementalComposition: {
  1: {
    name: "Carbon, C",
    value: 85.7,
    unit: "wt%"
  },

  2: {
    name: "Hydrogen, H",
    value: 13.3,
    unit: "wt%"
  },

  3: {
    name: "Sulfur, S",
    value: "0.04 - 0.06",
    unit: "wt%"
  },

  4: {
    name: "Nitrogen, N",
    value: "0.07 - 0.09",
    unit: "wt%"
  },

  5: {
    name: "Oxygen, O",
    value: 0.18,
    unit: "wt%"
  },

  6: {
    name: "H/C Ratio",
    value: 1.85,
    unit: ""
  }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: {
    name: "API Gravity @ 60°F",
    value: "35.0 - 37.5",
    unit: "°API"
  },

  8: {
    name: "Specific Gravity @ 60/60°F",
    value: 0.84,
    unit: ""
  },

  9: {
    name: "Density @ 15°C",
    value: 835,
    unit: "kg/m³"
  },

  10: {
    name: "Viscosity @ 20°C",
    value: 7.9,
    unit: "cSt"
  },

  11: {
    name: "Viscosity @ 40°C",
    value: 4.6,
    unit: "cSt"
  },

  12: {
    name: "Viscosity @ 50°C",
    value: "2.5 - 3.8",
    unit: "cSt"
  },

  13: {
    name: "Viscosity @ 100°C",
    value: 1.4,
    unit: "cSt"
  },

  14: {
    name: "Pour Point",
    value: "-18 to -30",
    unit: "°C"
  },

  15: {
    name: "Cloud Point",
    value: -28,
    unit: "°C"
  },

  16: {
    name: "Flash Point",
    value: "<21",
    unit: "°C"
  },

  17: {
    name: "Fire Point",
    value: 28,
    unit: "°C"
  },

  18: {
    name: "Reid Vapor Pressure (RVP)",
    value: 26.5,
    unit: "kPa"
  },

  19: {
    name: "Salt Content",
    value: "<10",
    unit: "PTB"
  },

  20: {
    name: "Water Content",
    value: "<0.1",
    unit: "vol%"
  },

  21: {
    name: "Sediment Content",
    value: "<0.01",
    unit: "wt%"
  },

  22: {
    name: "BS&W",
    value: "<0.1",
    unit: "vol%"
  },

  23: {
    name: "Ash Content",
    value: 0.01,
    unit: "wt%"
  }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: {
    name: "Total Acid Number (TAN)",
    value: "0.12 - 0.20",
    unit: "mgKOH/g"
  },

  25: {
    name: "Strong Acid Number (SAN)",
    value: "<0.01",
    unit: "mgKOH/g"
  },

  26: {
    name: "Mercaptan Sulfur",
    value: 1.5,
    unit: "mg/kg"
  },

  27: {
    name: "H₂S in Liquid",
    value: "<1",
    unit: "mg/kg"
  },

  28: {
    name: "H₂S Vapor",
    value: "<8",
    unit: "ppm"
  },

  29: {
    name: "Organic Chlorides",
    value: "<1",
    unit: "ppm"
  },

  30: {
    name: "Inorganic Chlorides",
    value: "Trace",
    unit: "mg/kg"
  }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: {
    name: "Nickel (Ni)",
    value: "2 - 3.5",
    unit: "ppm"
  },

  32: {
    name: "Vanadium (V)",
    value: "0 - 0.3",
    unit: "ppm"
  },

  33: {
    name: "Iron (Fe)",
    value: "1 - 2.5",
    unit: "ppm"
  },

  34: {
    name: "Sodium (Na)",
    value: "1 - 4",
    unit: "ppm"
  },

  35: {
    name: "Calcium (Ca)",
    value: "<5",
    unit: "ppm"
  },

  36: {
    name: "Magnesium (Mg)",
    value: "<1",
    unit: "ppm"
  },

  37: {
    name: "Copper (Cu)",
    value: "<0.5",
    unit: "ppm"
  },

  38: {
    name: "Lead (Pb)",
    value: "<0.5",
    unit: "ppm"
  },

  39: {
    name: "Zinc (Zn)",
    value: "<1",
    unit: "ppm"
  },

  40: {
    name: "Silicon (Si)",
    value: "<2",
    unit: "ppm"
  },

  41: {
    name: "Phosphorus (P)",
    value: "<1",
    unit: "ppm"
  },

  42: {
    name: "Arsenic (As)",
    value: "<10",
    unit: "ppb"
  },

  43: {
    name: "Mercury (Hg)",
    value: "<5",
    unit: "ppb"
  },

  44: {
    name: "Selenium (Se)",
    value: "<10",
    unit: "ppb"
  }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: {
    name: "Saturates",
    value: 66,
    unit: "wt%"
  },

  46: {
    name: "Aromatics",
    value: 24,
    unit: "wt%"
  },

  47: {
    name: "Resins",
    value: 8,
    unit: "wt%"
  },

  48: {
    name: "Asphaltenes (nC7)",
    value: "0.02 - 0.15",
    unit: "wt%"
  },

  49: {
    name: "Asphaltenes (nC5)",
    value: 0.45,
    unit: "wt%"
  },

  50: {
    name: "Wax Content",
    value: 14.8,
    unit: "wt%"
  }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: {
    name: "Methane (C1)",
    value: 0.02,
    unit: "wt%"
  },

  52: {
    name: "Ethane (C2)",
    value: 0.02,
    unit: "wt%"
  },

  53: {
    name: "Propane (C3)",
    value: 0.20,
    unit: "wt%"
  },

  54: {
    name: "i-Butane",
    value: 0.26,
    unit: "wt%"
  },

  55: {
    name: "n-Butane",
    value: 0.58,
    unit: "wt%"
  },

  56: {
    name: "i-Pentane",
    value: 0.95,
    unit: "wt%"
  },

  57: {
    name: "n-Pentane",
    value: 1.15,
    unit: "wt%"
  },

  58: {
    name: "Cyclopentane",
    value: 0.18,
    unit: "wt%"
  },

  59: {
    name: "C6 Hydrocarbons",
    value: 3.3,
    unit: "wt%"
  },

  60: {
    name: "C7 Hydrocarbons",
    value: 3.9,
    unit: "wt%"
  },

  61: {
    name: "C8 Hydrocarbons",
    value: 4.3,
    unit: "wt%"
  },

  62: {
    name: "C9 Hydrocarbons",
    value: 3.8,
    unit: "wt%"
  },

  63: {
    name: "C10 Hydrocarbons",
    value: 3.4,
    unit: "wt%"
  },

  64: {
    name: "Benzene",
    value: 0.18,
    unit: "vol%"
  },

  65: {
    name: "Toluene",
    value: 0.55,
    unit: "wt%"
  },

  66: {
    name: "Ethylbenzene",
    value: 140,
    unit: "ppm"
  },

  67: {
    name: "Xylenes",
    value: 0.38,
    unit: "wt%"
  },

  68: {
    name: "CO₂",
    value: "<0.1",
    unit: "wt%"
  },

  69: {
    name: "N₂",
    value: "<0.05",
    unit: "wt%"
  }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: {
    name: "IBP",
    value: 14,
    unit: "°C"
  },

  71: {
    name: "5% recovered",
    value: 48,
    unit: "°C"
  },

  72: {
    name: "10% recovered",
    value: 78,
    unit: "°C"
  },

  73: {
    name: "20% recovered",
    value: 145,
    unit: "°C"
  },

  74: {
    name: "30% recovered",
    value: 172,
    unit: "°C"
  },

  75: {
    name: "40% recovered",
    value: 225,
    unit: "°C"
  },

  76: {
    name: "50% recovered",
    value: 275,
    unit: "°C"
  },

  77: {
    name: "60% recovered",
    value: 320,
    unit: "°C"
  },

  78: {
    name: "70% recovered",
    value: 348,
    unit: "°C"
  },

  79: {
    name: "80% recovered",
    value: 372,
    unit: "°C"
  },

  80: {
    name: "90% recovered",
    value: 545,
    unit: "°C"
  },

  81: {
    name: "95% recovered",
    value: 560,
    unit: "°C"
  },

  82: {
    name: "FBP",
    value: 565,
    unit: "°C"
  },

  83: {
    name: "% recovered @ 360°C",
    value: 71,
    unit: "vol%"
  },

  84: {
    name: "% recovered @ 540°C",
    value: 91,
    unit: "vol%"
  }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: {
      value: 1.35,
      unit: "wt%"
    },

    vol: {
      value: 2.05,
      unit: "vol%"
    }
  },

  LightNaphtha: {
    wt: {
      value: 4.85,
      unit: "wt%"
    },

    vol: {
      value: 6.10,
      unit: "vol%"
    },

    density: {
      value: 650,
      unit: "kg/m³"
    },

    RON: {
      value: 76.8,
      unit: ""
    }
  },

  HeavyNaphtha: {
    wt: {
      value: 17.2,
      unit: "wt%"
    },

    vol: {
      value: 19.0,
      unit: "vol%"
    },

    density: {
      value: 765,
      unit: "kg/m³"
    }
  },

  Kerosene: {
    wt: {
      value: 15.0,
      unit: "wt%"
    },

    vol: {
      value: 15.5,
      unit: "vol%"
    },

    smokePt: {
      value: 22,
      unit: "mm"
    },

    freeze: {
      value: -60,
      unit: "°C"
    }
  },

  Diesel: {
    wt: {
      value: 34.2,
      unit: "wt%"
    },

    vol: {
      value: 33.5,
      unit: "vol%"
    },

    cetane: {
      value: 47,
      unit: ""
    },

    pour: {
      value: -10,
      unit: "°C"
    }
  },

  VGO: {
    wt: {
      value: 21.0,
      unit: "wt%"
    },

    vol: {
      value: 19.2,
      unit: "vol%"
    }
  },

  Residue: {
    wt: {
      value: 9.8,
      unit: "wt%"
    },

    vol: {
      value: 8.2,
      unit: "vol%"
    }
  }
},

/* ================= I. RESIDUE ================= */
residueProperties: {
  99: {
    name: "CCR",
    value: 1.3,
    unit: "wt%"
  },

  100: {
    name: "MCR",
    value: "variable",
    unit: ""
  },

  101: {
    name: "Ramsbottom Carbon",
    value: "low",
    unit: ""
  },

  102: {
    name: "Asphaltene Stability",
    value: ">5",
    unit: ""
  },

  103: {
    name: "Heptane Insolubles",
    value: 0.18,
    unit: "wt%"
  },

  104: {
    name: "Toluene Insolubles",
    value: "<0.05",
    unit: "wt%"
  },

  105: {
    name: "UOP K Factor",
    value: 11.75,
    unit: ""
  },

  106: {
    name: "Characterization Factor",
    value: 11.8,
    unit: ""
  }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Light Sweet Crude",
  "Low Sulfur (0.04–0.06%)",
  "Very Low Metals",
  "High Diesel Yield",
  "Waxy crude (14–15%)",
  "Good refinery feedstock",
  "Stable, low TAN crude"
]
 },



  FORCADOS: {
  name: "Forcados Crude Oil",
  country: "Nigeria",
  type: "Medium Sweet Crude",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
bulkElementalComposition: {
  1: {
    name: "Carbon, C",
    value: 86.2,
    unit: "wt%"
  },

  2: {
    name: "Hydrogen, H",
    value: 13.1,
    unit: "wt%"
  },

  3: {
    name: "Sulfur, S",
    value: "0.10 - 0.18",
    unit: "wt%"
  },

  4: {
    name: "Nitrogen, N",
    value: "0.08 - 0.11",
    unit: "wt%"
  },

  5: {
    name: "Oxygen, O",
    value: 0.22,
    unit: "wt%"
  },

  6: {
    name: "H/C Ratio",
    value: 1.83,
    unit: ""
  }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: {
    name: "API Gravity @ 60°F",
    value: "30.5 - 32.8",
    unit: "°API"
  },

  8: {
    name: "Specific Gravity @ 60/60°F",
    value: 0.87,
    unit: ""
  },

  9: {
    name: "Density @ 15°C",
    value: 860,
    unit: "kg/m³"
  },

  10: {
    name: "Viscosity @ 20°C",
    value: 10.2,
    unit: "cSt"
  },

  11: {
    name: "Viscosity @ 40°C",
    value: 6.1,
    unit: "cSt"
  },

  12: {
    name: "Viscosity @ 50°C",
    value: "3.8 - 5.2",
    unit: "cSt"
  },

  13: {
    name: "Viscosity @ 100°C",
    value: 1.8,
    unit: "cSt"
  },

  14: {
    name: "Pour Point",
    value: "-9 to -24",
    unit: "°C"
  },

  15: {
    name: "Cloud Point",
    value: -18,
    unit: "°C"
  },

  16: {
    name: "Flash Point",
    value: "<23",
    unit: "°C"
  },

  17: {
    name: "Fire Point",
    value: 32,
    unit: "°C"
  },

  18: {
    name: "Reid Vapor Pressure (RVP)",
    value: 28.0,
    unit: "kPa"
  },

  19: {
    name: "Salt Content",
    value: "<12",
    unit: "PTB"
  },

  20: {
    name: "Water Content",
    value: "<0.15",
    unit: "vol%"
  },

  21: {
    name: "Sediment Content",
    value: "<0.02",
    unit: "wt%"
  },

  22: {
    name: "BS&W",
    value: "<0.2",
    unit: "vol%"
  },

  23: {
    name: "Ash Content",
    value: 0.02,
    unit: "wt%"
  }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: {
    name: "Total Acid Number (TAN)",
    value: "0.20 - 0.35",
    unit: "mgKOH/g"
  },

  25: {
    name: "Strong Acid Number (SAN)",
    value: "<0.02",
    unit: "mgKOH/g"
  },

  26: {
    name: "Mercaptan Sulfur",
    value: 3.2,
    unit: "mg/kg"
  },

  27: {
    name: "H₂S in Liquid",
    value: "<2",
    unit: "mg/kg"
  },

  28: {
    name: "H₂S Vapor",
    value: "<15",
    unit: "ppm"
  },

  29: {
    name: "Organic Chlorides",
    value: "<2",
    unit: "ppm"
  },

  30: {
    name: "Inorganic Chlorides",
    value: "Trace - Low",
    unit: "mg/kg"
  }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: {
    name: "Nickel (Ni)",
    value: "4 - 6",
    unit: "ppm"
  },

  32: {
    name: "Vanadium (V)",
    value: "0.3 - 0.8",
    unit: "ppm"
  },

  33: {
    name: "Iron (Fe)",
    value: "2 - 5",
    unit: "ppm"
  },

  34: {
    name: "Sodium (Na)",
    value: "2 - 6",
    unit: "ppm"
  },

  35: {
    name: "Calcium (Ca)",
    value: "<6",
    unit: "ppm"
  },

  36: {
    name: "Magnesium (Mg)",
    value: "<2",
    unit: "ppm"
  },

  37: {
    name: "Copper (Cu)",
    value: "<1",
    unit: "ppm"
  },

  38: {
    name: "Lead (Pb)",
    value: "<1",
    unit: "ppm"
  },

  39: {
    name: "Zinc (Zn)",
    value: "<2",
    unit: "ppm"
  },

  40: {
    name: "Silicon (Si)",
    value: "<3",
    unit: "ppm"
  },

  41: {
    name: "Phosphorus (P)",
    value: "<1",
    unit: "ppm"
  },

  42: {
    name: "Arsenic (As)",
    value: "<15",
    unit: "ppb"
  },

  43: {
    name: "Mercury (Hg)",
    value: "<8",
    unit: "ppb"
  },

  44: {
    name: "Selenium (Se)",
    value: "<12",
    unit: "ppb"
  }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: {
    name: "Saturates",
    value: 62,
    unit: "wt%"
  },

  46: {
    name: "Aromatics",
    value: 27,
    unit: "wt%"
  },

  47: {
    name: "Resins",
    value: 10,
    unit: "wt%"
  },

  48: {
    name: "Asphaltenes (nC7)",
    value: "0.1 - 0.4",
    unit: "wt%"
  },

  49: {
    name: "Asphaltenes (nC5)",
    value: 0.6,
    unit: "wt%"
  },

  50: {
    name: "Wax Content",
    value: 16.5,
    unit: "wt%"
  }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: {
    name: "Methane (C1)",
    value: 0.03,
    unit: "wt%"
  },

  52: {
    name: "Ethane (C2)",
    value: 0.03,
    unit: "wt%"
  },

  53: {
    name: "Propane (C3)",
    value: 0.25,
    unit: "wt%"
  },

  54: {
    name: "i-Butane",
    value: 0.30,
    unit: "wt%"
  },

  55: {
    name: "n-Butane",
    value: 0.65,
    unit: "wt%"
  },

  56: {
    name: "i-Pentane",
    value: 1.05,
    unit: "wt%"
  },

  57: {
    name: "n-Pentane",
    value: 1.25,
    unit: "wt%"
  },

  58: {
    name: "Cyclopentane",
    value: 0.22,
    unit: "wt%"
  },

  59: {
    name: "C6 Hydrocarbons",
    value: 3.8,
    unit: "wt%"
  },

  60: {
    name: "C7 Hydrocarbons",
    value: 4.2,
    unit: "wt%"
  },

  61: {
    name: "C8 Hydrocarbons",
    value: 4.8,
    unit: "wt%"
  },

  62: {
    name: "C9 Hydrocarbons",
    value: 4.3,
    unit: "wt%"
  },

  63: {
    name: "C10 Hydrocarbons",
    value: 3.9,
    unit: "wt%"
  },

  64: {
    name: "Benzene",
    value: 0.22,
    unit: "vol%"
  },

  65: {
    name: "Toluene",
    value: 0.65,
    unit: "wt%"
  },

  66: {
    name: "Ethylbenzene",
    value: 170,
    unit: "ppm"
  },

  67: {
    name: "Xylenes",
    value: 0.45,
    unit: "wt%"
  },

  68: {
    name: "CO₂",
    value: "<0.12",
    unit: "wt%"
  },

  69: {
    name: "N₂",
    value: "<0.06",
    unit: "wt%"
  }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: {
    name: "IBP",
    value: 16,
    unit: "°C"
  },

  71: {
    name: "5% recovered",
    value: 55,
    unit: "°C"
  },

  72: {
    name: "10% recovered",
    value: 85,
    unit: "°C"
  },

  73: {
    name: "20% recovered",
    value: 155,
    unit: "°C"
  },

  74: {
    name: "30% recovered",
    value: 185,
    unit: "°C"
  },

  75: {
    name: "40% recovered",
    value: 240,
    unit: "°C"
  },

  76: {
    name: "50% recovered",
    value: 290,
    unit: "°C"
  },

  77: {
    name: "60% recovered",
    value: 335,
    unit: "°C"
  },

  78: {
    name: "70% recovered",
    value: 360,
    unit: "°C"
  },

  79: {
    name: "80% recovered",
    value: 385,
    unit: "°C"
  },

  80: {
    name: "90% recovered",
    value: 560,
    unit: "°C"
  },

  81: {
    name: "95% recovered",
    value: 575,
    unit: "°C"
  },

  82: {
    name: "FBP",
    value: 580,
    unit: "°C"
  },

  83: {
    name: "% recovered @ 360°C",
    value: 70,
    unit: "vol%"
  },

  84: {
    name: "% recovered @ 540°C",
    value: 90,
    unit: "vol%"
  }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: {
      value: 1.6,
      unit: "wt%"
    },

    vol: {
      value: 2.4,
      unit: "vol%"
    }
  },

  LightNaphtha: {
    wt: {
      value: 5.2,
      unit: "wt%"
    },

    vol: {
      value: 6.5,
      unit: "vol%"
    },

    density: {
      value: 660,
      unit: "kg/m³"
    },

    RON: {
      value: 78.5,
      unit: ""
    }
  },

  HeavyNaphtha: {
    wt: {
      value: 18.1,
      unit: "wt%"
    },

    vol: {
      value: 19.8,
      unit: "vol%"
    },

    density: {
      value: 775,
      unit: "kg/m³"
    }
  },

  Kerosene: {
    wt: {
      value: 16.0,
      unit: "wt%"
    },

    vol: {
      value: 16.4,
      unit: "vol%"
    },

    smokePt: {
      value: 20,
      unit: "mm"
    },

    freeze: {
      value: -58,
      unit: "°C"
    }
  },

  Diesel: {
    wt: {
      value: 32.8,
      unit: "wt%"
    },

    vol: {
      value: 32.0,
      unit: "vol%"
    },

    cetane: {
      value: 45,
      unit: ""
    },

    pour: {
      value: -8,
      unit: "°C"
    }
  },

  VGO: {
    wt: {
      value: 20.5,
      unit: "wt%"
    },

    vol: {
      value: 18.9,
      unit: "vol%"
    }
  },

  Residue: {
    wt: {
      value: 10.3,
      unit: "wt%"
    },

    vol: {
      value: 9.0,
      unit: "vol%"
    }
  }
},

/* ================= I. RESIDUE ================= */
residueProperties: {
  99: {
    name: "CCR",
    value: 1.8,
    unit: "wt%"
  },

  100: {
    name: "MCR",
    value: "variable",
    unit: ""
  },

  101: {
    name: "Ramsbottom Carbon",
    value: "moderate",
    unit: ""
  },

  102: {
    name: "Asphaltene Stability",
    value: ">4.8",
    unit: ""
  },

  103: {
    name: "Heptane Insolubles",
    value: 0.25,
    unit: "wt%"
  },

  104: {
    name: "Toluene Insolubles",
    value: "<0.06",
    unit: "wt%"
  },

  105: {
    name: "UOP K Factor",
    value: 11.55,
    unit: ""
  },

  106: {
    name: "Characterization Factor",
    value: 11.6,
    unit: ""
  }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Medium Sweet Crude",
  "Higher sulfur than Qua Iboe",
  "Moderate TAN (more corrosive than Qua Iboe)",
  "Good diesel yield (~32%)",
  "Higher metals than Bonny Light",
  "Stable refinery feedstock",
  "Balanced cut distribution"
]
},


ESCRAVOS: {
  name: "Escravos Crude Oil",
  country: "Nigeria",
  type: "Medium Sweet Crude",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
bulkElementalComposition: {
  1: { name: "Carbon, C", value: 85.9, unit: "wt%" },
  2: { name: "Hydrogen, H", value: 13.0, unit: "wt%" },
  3: { name: "Sulfur, S", value: "0.12 - 0.22", unit: "wt%" },
  4: { name: "Nitrogen, N", value: "0.08 - 0.12", unit: "wt%" },
  5: { name: "Oxygen, O", value: 0.25, unit: "wt%" },
  6: { name: "H/C Ratio", value: 1.82, unit: "" }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: { name: "API Gravity @ 60°F", value: "29.5 - 32.0", unit: "°API" },
  8: { name: "Specific Gravity @ 60/60°F", value: 0.88, unit: "" },
  9: { name: "Density @ 15°C", value: 870, unit: "kg/m³" },
  10: { name: "Viscosity @ 20°C", value: 11.5, unit: "cSt" },
  11: { name: "Viscosity @ 40°C", value: 6.8, unit: "cSt" },
  12: { name: "Viscosity @ 50°C", value: "4.2 - 5.8", unit: "cSt" },
  13: { name: "Viscosity @ 100°C", value: 2.0, unit: "cSt" },
  14: { name: "Pour Point", value: "-6 to -18", unit: "°C" },
  15: { name: "Cloud Point", value: -15, unit: "°C" },
  16: { name: "Flash Point", value: "<24", unit: "°C" },
  17: { name: "Fire Point", value: 34, unit: "°C" },
  18: { name: "Reid Vapor Pressure (RVP)", value: 29.5, unit: "kPa" },
  19: { name: "Salt Content", value: "<15", unit: "PTB" },
  20: { name: "Water Content", value: "<0.2", unit: "vol%" },
  21: { name: "Sediment Content", value: "<0.03", unit: "wt%" },
  22: { name: "BS&W", value: "<0.25", unit: "vol%" },
  23: { name: "Ash Content", value: 0.02, unit: "wt%" }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: { name: "Total Acid Number (TAN)", value: "0.25 - 0.45", unit: "mgKOH/g" },
  25: { name: "Strong Acid Number (SAN)", value: "<0.02", unit: "mgKOH/g" },
  26: { name: "Mercaptan Sulfur", value: 4.0, unit: "ppm" },
  27: { name: "H₂S in Liquid", value: "<3", unit: "ppm" },
  28: { name: "H₂S Vapor", value: "<18", unit: "ppm" },
  29: { name: "Organic Chlorides", value: "<2", unit: "ppm" },
  30: { name: "Inorganic Chlorides", value: "Low - Trace", unit: "" }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: { name: "Nickel (Ni)", value: "5 - 8", unit: "ppm" },
  32: { name: "Vanadium (V)", value: "0.5 - 1.2", unit: "ppm" },
  33: { name: "Iron (Fe)", value: "3 - 6", unit: "ppm" },
  34: { name: "Sodium (Na)", value: "3 - 8", unit: "ppm" },
  35: { name: "Calcium (Ca)", value: "<7", unit: "ppm" },
  36: { name: "Magnesium (Mg)", value: "<2", unit: "ppm" },
  37: { name: "Copper (Cu)", value: "<1", unit: "ppm" },
  38: { name: "Lead (Pb)", value: "<1", unit: "ppm" },
  39: { name: "Zinc (Zn)", value: "<2", unit: "ppm" },
  40: { name: "Silicon (Si)", value: "<4", unit: "ppm" },
  41: { name: "Phosphorus (P)", value: "<2", unit: "ppm" },
  42: { name: "Arsenic (As)", value: "<20", unit: "ppb" },
  43: { name: "Mercury (Hg)", value: "<10", unit: "ppb" },
  44: { name: "Selenium (Se)", value: "<15", unit: "ppb" }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: { name: "Saturates", value: 60, unit: "wt%" },
  46: { name: "Aromatics", value: 28, unit: "wt%" },
  47: { name: "Resins", value: 11, unit: "wt%" },
  48: { name: "Asphaltenes (nC7)", value: "0.2 - 0.6", unit: "wt%" },
  49: { name: "Asphaltenes (nC5)", value: 0.7, unit: "wt%" },
  50: { name: "Wax Content", value: 17.8, unit: "wt%" }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: { name: "Methane (C1)", value: 0.04, unit: "wt%" },
  52: { name: "Ethane (C2)", value: 0.04, unit: "wt%" },
  53: { name: "Propane (C3)", value: 0.28, unit: "wt%" },
  54: { name: "i-Butane", value: 0.32, unit: "wt%" },
  55: { name: "n-Butane", value: 0.70, unit: "wt%" },
  56: { name: "i-Pentane", value: 1.10, unit: "wt%" },
  57: { name: "n-Pentane", value: 1.30, unit: "wt%" },
  58: { name: "Cyclopentane", value: 0.25, unit: "wt%" },
  59: { name: "C6 Hydrocarbons", value: 4.0, unit: "wt%" },
  60: { name: "C7 Hydrocarbons", value: 4.5, unit: "wt%" },
  61: { name: "C8 Hydrocarbons", value: 5.0, unit: "wt%" },
  62: { name: "C9 Hydrocarbons", value: 4.6, unit: "wt%" },
  63: { name: "C10 Hydrocarbons", value: 4.2, unit: "wt%" },
  64: { name: "Benzene", value: 0.25, unit: "vol%" },
  65: { name: "Toluene", value: 0.70, unit: "wt%" },
  66: { name: "Ethylbenzene", value: 190, unit: "ppm" },
  67: { name: "Xylenes", value: 0.50, unit: "wt%" },
  68: { name: "CO₂", value: "<0.15", unit: "wt%" },
  69: { name: "N₂", value: "<0.08", unit: "wt%" }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: { name: "IBP", value: 18, unit: "°C" },
  71: { name: "5% recovered", value: 60, unit: "°C" },
  72: { name: "10% recovered", value: 90, unit: "°C" },
  73: { name: "20% recovered", value: 160, unit: "°C" },
  74: { name: "30% recovered", value: 190, unit: "°C" },
  75: { name: "40% recovered", value: 245, unit: "°C" },
  76: { name: "50% recovered", value: 295, unit: "°C" },
  77: { name: "60% recovered", value: 340, unit: "°C" },
  78: { name: "70% recovered", value: 365, unit: "°C" },
  79: { name: "80% recovered", value: 395, unit: "°C" },
  80: { name: "90% recovered", value: 565, unit: "°C" },
  81: { name: "95% recovered", value: 580, unit: "°C" },
  82: { name: "FBP", value: 590, unit: "°C" },
  83: { name: "% recovered @ 360°C", value: 68, unit: "vol%" },
  84: { name: "% recovered @ 540°C", value: 88, unit: "vol%" }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: { value: 1.8, unit: "wt%" },
    vol: { value: 2.6, unit: "vol%" }
  },

  LightNaphtha: {
    wt: { value: 5.5, unit: "wt%" },
    vol: { value: 6.8, unit: "vol%" },
    density: { value: 665, unit: "kg/m³" },
    RON: { value: 79, unit: "" }
  },

  HeavyNaphtha: {
    wt: { value: 18.5, unit: "wt%" },
    vol: { value: 20.0, unit: "vol%" },
    density: { value: 780, unit: "kg/m³" }
  },

  Kerosene: {
    wt: { value: 16.5, unit: "wt%" },
    vol: { value: 16.8, unit: "vol%" },
    smokePt: { value: 19, unit: "mm" },
    freeze: { value: -56, unit: "°C" }
  },

  Diesel: {
    wt: { value: 31.5, unit: "wt%" },
    vol: { value: 31.0, unit: "vol%" },
    cetane: { value: 44, unit: "" },
    pour: { value: -7, unit: "°C" }
  },

  VGO: {
    wt: { value: 20.0, unit: "wt%" },
    vol: { value: 18.5, unit: "vol%" }
  },

  Residue: {
    wt: { value: 10.7, unit: "wt%" },
    vol: { value: 9.3, unit: "vol%" }
  }
},

/* ================= I. RESIDUE ================= */
residueProperties: {
  99: { name: "CCR", value: 2.0, unit: "wt%" },
  100: { name: "MCR", value: "variable", unit: "" },
  101: { name: "Ramsbottom Carbon", value: "moderate-high", unit: "" },
  102: { name: "Asphaltene Stability", value: ">4.5", unit: "" },
  103: { name: "Heptane Insolubles", value: 0.35, unit: "wt%" },
  104: { name: "Toluene Insolubles", value: "<0.07", unit: "wt%" },
  105: { name: "UOP K Factor", value: 11.45, unit: "" },
  106: { name: "Characterization Factor", value: 11.55, unit: "" }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Medium Sweet Crude",
  "Higher sulfur than Bonny Light & Qua Iboe",
  "Higher TAN (more corrosive)",
  "Moderate diesel yield (~31%)",
  "Higher metals content",
  "Heavier than Qua Iboe",
  "Good FCC feed but more treating required"
]
},


ARAB_LIGHT: {
  name: "Arab Light Crude Oil",
  country: "Saudi Arabia",
  type: "Light Sweet Crude",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
bulkElementalComposition: {
  1: { name: "Carbon, C", value: 85.5, unit: "wt%" },
  2: { name: "Hydrogen, H", value: 13.2, unit: "wt%" },
  3: { name: "Sulfur, S", value: "1.2 - 1.8", unit: "wt%" },
  4: { name: "Nitrogen, N", value: "0.08 - 0.10", unit: "wt%" },
  5: { name: "Oxygen, O", value: 0.25, unit: "wt%" },
  6: { name: "H/C Ratio", value: 1.78, unit: "" }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: { name: "API Gravity @ 60°F", value: "31.5 - 34.0", unit: "°API" },
  8: { name: "Specific Gravity @ 60/60°F", value: 0.87, unit: "" },
  9: { name: "Density @ 15°C", value: 865, unit: "kg/m³" },
  10: { name: "Viscosity @ 20°C", value: 9.8, unit: "cSt" },
  11: { name: "Viscosity @ 40°C", value: 5.9, unit: "cSt" },
  12: { name: "Viscosity @ 50°C", value: "3.6 - 5.0", unit: "cSt" },
  13: { name: "Viscosity @ 100°C", value: 1.7, unit: "cSt" },
  14: { name: "Pour Point", value: "-6 to -18", unit: "°C" },
  15: { name: "Cloud Point", value: -10, unit: "°C" },
  16: { name: "Flash Point", value: "<25", unit: "°C" },
  17: { name: "Fire Point", value: 36, unit: "°C" },
  18: { name: "Reid Vapor Pressure (RVP)", value: 28.5, unit: "kPa" },
  19: { name: "Salt Content", value: "<20", unit: "PTB" },
  20: { name: "Water Content", value: "<0.2", unit: "vol%" },
  21: { name: "Sediment Content", value: "<0.03", unit: "wt%" },
  22: { name: "BS&W", value: "<0.25", unit: "vol%" },
  23: { name: "Ash Content", value: 0.02, unit: "wt%" }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: { name: "Total Acid Number (TAN)", value: "0.30 - 0.60", unit: "mgKOH/g" },
  25: { name: "Strong Acid Number (SAN)", value: "<0.03", unit: "mgKOH/g" },
  26: { name: "Mercaptan Sulfur", value: 6.0, unit: "ppm" },
  27: { name: "H₂S in Liquid", value: "<5", unit: "ppm" },
  28: { name: "H₂S Vapor", value: "<25", unit: "ppm" },
  29: { name: "Organic Chlorides", value: "<3", unit: "ppm" },
  30: { name: "Inorganic Chlorides", value: "Moderate", unit: "" }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: { name: "Nickel (Ni)", value: "8 - 15", unit: "ppm" },
  32: { name: "Vanadium (V)", value: "2 - 5", unit: "ppm" },
  33: { name: "Iron (Fe)", value: "5 - 12", unit: "ppm" },
  34: { name: "Sodium (Na)", value: "5 - 15", unit: "ppm" },
  35: { name: "Calcium (Ca)", value: "<10", unit: "ppm" },
  36: { name: "Magnesium (Mg)", value: "<3", unit: "ppm" },
  37: { name: "Copper (Cu)", value: "<2", unit: "ppm" },
  38: { name: "Lead (Pb)", value: "<2", unit: "ppm" },
  39: { name: "Zinc (Zn)", value: "<3", unit: "ppm" },
  40: { name: "Silicon (Si)", value: "<5", unit: "ppm" },
  41: { name: "Phosphorus (P)", value: "<3", unit: "ppm" },
  42: { name: "Arsenic (As)", value: "<30", unit: "ppb" },
  43: { name: "Mercury (Hg)", value: "<20", unit: "ppb" },
  44: { name: "Selenium (Se)", value: "<20", unit: "ppb" }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: { name: "Saturates", value: 55, unit: "wt%" },
  46: { name: "Aromatics", value: 30, unit: "wt%" },
  47: { name: "Resins", value: 12, unit: "wt%" },
  48: { name: "Asphaltenes (nC7)", value: "0.5 - 1.5", unit: "wt%" },
  49: { name: "Asphaltenes (nC5)", value: 1.8, unit: "wt%" },
  50: { name: "Wax Content", value: 12.0, unit: "wt%" }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: { name: "Methane (C1)", value: 0.05, unit: "wt%" },
  52: { name: "Ethane (C2)", value: 0.05, unit: "wt%" },
  53: { name: "Propane (C3)", value: 0.35, unit: "wt%" },
  54: { name: "i-Butane", value: 0.40, unit: "wt%" },
  55: { name: "n-Butane", value: 0.80, unit: "wt%" },
  56: { name: "i-Pentane", value: 1.30, unit: "wt%" },
  57: { name: "n-Pentane", value: 1.50, unit: "wt%" },
  58: { name: "Cyclopentane", value: 0.30, unit: "wt%" },
  59: { name: "C6 Hydrocarbons", value: 4.5, unit: "wt%" },
  60: { name: "C7 Hydrocarbons", value: 5.0, unit: "wt%" },
  61: { name: "C8 Hydrocarbons", value: 5.5, unit: "wt%" },
  62: { name: "C9 Hydrocarbons", value: 5.0, unit: "wt%" },
  63: { name: "C10 Hydrocarbons", value: 4.5, unit: "wt%" },
  64: { name: "Benzene", value: 0.30, unit: "vol%" },
  65: { name: "Toluene", value: 0.80, unit: "wt%" },
  66: { name: "Ethylbenzene", value: 220, unit: "ppm" },
  67: { name: "Xylenes", value: 0.60, unit: "wt%" },
  68: { name: "CO₂", value: "<0.20", unit: "wt%" },
  69: { name: "N₂", value: "<0.10", unit: "wt%" }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: { name: "IBP", value: 20, unit: "°C" },
  71: { name: "5% recovered", value: 65, unit: "°C" },
  72: { name: "10% recovered", value: 95, unit: "°C" },
  73: { name: "20% recovered", value: 165, unit: "°C" },
  74: { name: "30% recovered", value: 195, unit: "°C" },
  75: { name: "40% recovered", value: 250, unit: "°C" },
  76: { name: "50% recovered", value: 300, unit: "°C" },
  77: { name: "60% recovered", value: 345, unit: "°C" },
  78: { name: "70% recovered", value: 370, unit: "°C" },
  79: { name: "80% recovered", value: 400, unit: "°C" },
  80: { name: "90% recovered", value: 570, unit: "°C" },
  81: { name: "95% recovered", value: 585, unit: "°C" },
  82: { name: "FBP", value: 600, unit: "°C" },
  83: { name: "% recovered @ 360°C", value: 65, unit: "vol%" },
  84: { name: "% recovered @ 540°C", value: 85, unit: "vol%" }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: { value: 2.2, unit: "wt%" },
    vol: { value: 3.0, unit: "vol%" }
  },

  LightNaphtha: {
    wt: { value: 6.0, unit: "wt%" },
    vol: { value: 7.2, unit: "vol%" },
    density: { value: 670, unit: "kg/m³" },
    RON: { value: 80, unit: "" }
  },

  HeavyNaphtha: {
    wt: { value: 19.0, unit: "wt%" },
    vol: { value: 20.5, unit: "vol%" },
    density: { value: 790, unit: "kg/m³" }
  },

  Kerosene: {
    wt: { value: 17.0, unit: "wt%" },
    vol: { value: 17.2, unit: "vol%" },
    smokePt: { value: 18, unit: "mm" },
    freeze: { value: -54, unit: "°C" }
  },

  Diesel: {
    wt: { value: 30.0, unit: "wt%" },
    vol: { value: 29.5, unit: "vol%" },
    cetane: { value: 42, unit: "" },
    pour: { value: -5, unit: "°C" }
  },

  VGO: {
    wt: { value: 19.5, unit: "wt%" },
    vol: { value: 18.0, unit: "vol%" }
  },

  Residue: {
    wt: { value: 12.3, unit: "wt%" },
    vol: { value: 10.5, unit: "vol%" }
  }
},

/* ================= I. RESIDUE ================= */
residueProperties: {
  99: { name: "CCR", value: 3.0, unit: "wt%" },
  100: { name: "MCR", value: "high", unit: "" },
  101: { name: "Ramsbottom Carbon", value: "high", unit: "" },
  102: { name: "Asphaltene Stability", value: ">4.0", unit: "" },
  103: { name: "Heptane Insolubles", value: 0.8, unit: "wt%" },
  104: { name: "Toluene Insolubles", value: "<0.1", unit: "wt%" },
  105: { name: "UOP K Factor", value: 11.2, unit: "" },
  106: { name: "Characterization Factor", value: 11.3, unit: "" }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Medium Sour Crude",
  "Higher sulfur than Nigerian crudes",
  "Higher metals content",
  "Lower refinery premium than Qua Iboe / Bonny Light",
  "Stable but requires more hydrotreating",
  "Good middle distillate yield",
  "Widely used global benchmark crude"
]
},

MURBAN: {
  name: "Murban Crude Oil",
  country: "United Arab Emirates",
  type: "Ultra-Light Sweet Crude",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
bulkElementalComposition: {
  1: { name: "Carbon, C", value: 84.8, unit: "wt%" },
  2: { name: "Hydrogen, H", value: 13.6, unit: "wt%" },
  3: { name: "Sulfur, S", value: "0.78 - 0.92", unit: "wt%" },
  4: { name: "Nitrogen, N", value: "0.05 - 0.08", unit: "wt%" },
  5: { name: "Oxygen, O", value: 0.18, unit: "wt%" },
  6: { name: "H/C Ratio", value: 1.90, unit: "" }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: { name: "API Gravity @ 60°F", value: "39.5 - 41.5", unit: "°API" },
  8: { name: "Specific Gravity @ 60/60°F", value: 0.83, unit: "" },
  9: { name: "Density @ 15°C", value: 820, unit: "kg/m³" },
  10: { name: "Viscosity @ 20°C", value: 5.2, unit: "cSt" },
  11: { name: "Viscosity @ 40°C", value: 3.1, unit: "cSt" },
  12: { name: "Viscosity @ 50°C", value: "2.0 - 3.0", unit: "cSt" },
  13: { name: "Viscosity @ 100°C", value: 1.1, unit: "cSt" },
  14: { name: "Pour Point", value: "-20 to -33", unit: "°C" },
  15: { name: "Cloud Point", value: -25, unit: "°C" },
  16: { name: "Flash Point", value: "<18", unit: "°C" },
  17: { name: "Fire Point", value: 26, unit: "°C" },
  18: { name: "Reid Vapor Pressure (RVP)", value: 35.0, unit: "kPa" },
  19: { name: "Salt Content", value: "<8", unit: "PTB" },
  20: { name: "Water Content", value: "<0.05", unit: "vol%" },
  21: { name: "Sediment Content", value: "<0.01", unit: "wt%" },
  22: { name: "BS&W", value: "<0.1", unit: "vol%" },
  23: { name: "Ash Content", value: 0.008, unit: "wt%" }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: { name: "Total Acid Number (TAN)", value: "0.10 - 0.18", unit: "mg KOH/g" },
  25: { name: "Strong Acid Number (SAN)", value: "<0.005", unit: "mg KOH/g" },
  26: { name: "Mercaptan Sulfur", value: 1.2, unit: "ppm" },
  27: { name: "H₂S in Liquid", value: "<0.5", unit: "ppm" },
  28: { name: "H₂S Vapor", value: "<5", unit: "ppm" },
  29: { name: "Organic Chlorides", value: "<1", unit: "ppm" },
  30: { name: "Inorganic Chlorides", value: "Very Low", unit: "" }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: { name: "Nickel (Ni)", value: "0.5 - 1.5", unit: "ppm" },
  32: { name: "Vanadium (V)", value: "0.1 - 0.5", unit: "ppm" },
  33: { name: "Iron (Fe)", value: "0.5 - 2", unit: "ppm" },
  34: { name: "Sodium (Na)", value: "1 - 3", unit: "ppm" },
  35: { name: "Calcium (Ca)", value: "<2", unit: "ppm" },
  36: { name: "Magnesium (Mg)", value: "<1", unit: "ppm" },
  37: { name: "Copper (Cu)", value: "<0.5", unit: "ppm" },
  38: { name: "Lead (Pb)", value: "<0.5", unit: "ppm" },
  39: { name: "Zinc (Zn)", value: "<1", unit: "ppm" },
  40: { name: "Silicon (Si)", value: "<1", unit: "ppm" },
  41: { name: "Phosphorus (P)", value: "<1", unit: "ppm" },
  42: { name: "Arsenic (As)", value: "<5", unit: "ppb" },
  43: { name: "Mercury (Hg)", value: "<3", unit: "ppb" },
  44: { name: "Selenium (Se)", value: "<5", unit: "ppb" }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: { name: "Saturates", value: 70, unit: "wt%" },
  46: { name: "Aromatics", value: 22, unit: "wt%" },
  47: { name: "Resins", value: 6, unit: "wt%" },
  48: { name: "Asphaltenes (nC7)", value: "0.1 - 0.3", unit: "wt%" },
  49: { name: "Asphaltenes (nC5)", value: 0.4, unit: "wt%" },
  50: { name: "Wax Content", value: 9.5, unit: "wt%" }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: { name: "Methane (C1)", value: 0.01, unit: "wt%" },
  52: { name: "Ethane (C2)", value: 0.01, unit: "wt%" },
  53: { name: "Propane (C3)", value: 0.12, unit: "wt%" },
  54: { name: "i-Butane", value: 0.15, unit: "wt%" },
  55: { name: "n-Butane", value: 0.35, unit: "wt%" },
  56: { name: "i-Pentane", value: 0.70, unit: "wt%" },
  57: { name: "n-Pentane", value: 0.90, unit: "wt%" },
  58: { name: "Cyclopentane", value: 0.15, unit: "wt%" },
  59: { name: "C6 Hydrocarbons", value: 2.8, unit: "wt%" },
  60: { name: "C7 Hydrocarbons", value: 3.2, unit: "wt%" },
  61: { name: "C8 Hydrocarbons", value: 3.5, unit: "wt%" },
  62: { name: "C9 Hydrocarbons", value: 3.0, unit: "wt%" },
  63: { name: "C10 Hydrocarbons", value: 2.5, unit: "wt%" },
  64: { name: "Benzene", value: 0.10, unit: "vol%" },
  65: { name: "Toluene", value: 0.35, unit: "wt%" },
  66: { name: "Ethylbenzene", value: 90, unit: "ppm" },
  67: { name: "Xylenes", value: 0.25, unit: "wt%" },
  68: { name: "CO₂", value: "<0.05", unit: "wt%" },
  69: { name: "N₂", value: "<0.03", unit: "wt%" }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: { name: "IBP", value: 10, unit: "°C" },
  71: { name: "5% recovered", value: 40, unit: "°C" },
  72: { name: "10% recovered", value: 70, unit: "°C" },
  73: { name: "20% recovered", value: 120, unit: "°C" },
  74: { name: "30% recovered", value: 150, unit: "°C" },
  75: { name: "40% recovered", value: 200, unit: "°C" },
  76: { name: "50% recovered", value: 240, unit: "°C" },
  77: { name: "60% recovered", value: 290, unit: "°C" },
  78: { name: "70% recovered", value: 330, unit: "°C" },
  79: { name: "80% recovered", value: 360, unit: "°C" },
  80: { name: "90% recovered", value: 520, unit: "°C" },
  81: { name: "95% recovered", value: 540, unit: "°C" },
  82: { name: "FBP", value: 560, unit: "°C" },
  83: { name: "% recovered @ 360°C", value: 78, unit: "vol%" },
  84: { name: "% recovered @ 540°C", value: 95, unit: "vol%" }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: { value: 1.2, unit: "wt%" },
    vol: { value: 1.8, unit: "vol%" }
  },

  LightNaphtha: {
    wt: { value: 8.5, unit: "wt%" },
    vol: { value: 9.5, unit: "vol%" },
    density: { value: 640, unit: "kg/m³" },
    RON: { value: 82, unit: "" }
  },

  HeavyNaphtha: {
    wt: { value: 22.0, unit: "wt%" },
    vol: { value: 23.0, unit: "vol%" },
    density: { value: 760, unit: "kg/m³" }
  },

  Kerosene: {
    wt: { value: 18.5, unit: "wt%" },
    vol: { value: 19.0, unit: "vol%" },
    smokePt: { value: 23, unit: "mm" },
    freeze: { value: -60, unit: "°C" }
  },

  Diesel: {
    wt: { value: 28.0, unit: "wt%" },
    vol: { value: 27.5, unit: "vol%" },
    cetane: { value: 50, unit: "" },
    pour: { value: -18, unit: "°C" }
  },

  VGO: {
    wt: { value: 15.0, unit: "wt%" },
    vol: { value: 14.0, unit: "vol%" }
  },

  Residue: {
    wt: { value: 6.8, unit: "wt%" },
    vol: { value: 5.2, unit: "vol%" }
  }
},

/* ================= I. RESIDUE ================= */
residueProperties: {
  99: { name: "CCR", value: 0.8, unit: "wt%" },
  100: { name: "MCR", value: "very low", unit: "" },
  101: { name: "Ramsbottom Carbon", value: "very low", unit: "" },
  102: { name: "Asphaltene Stability", value: ">6.0", unit: "" },
  103: { name: "Heptane Insolubles", value: 0.1, unit: "wt%" },
  104: { name: "Toluene Insolubles", value: "<0.02", unit: "wt%" },
  105: { name: "UOP K Factor", value: 12.1, unit: "" },
  106: { name: "Characterization Factor", value: 12.0, unit: "" }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Ultra-light sweet crude",
  "Highest API among your dataset",
  "Very low sulfur",
  "Very low residue yield",
  "Excellent gasoline yield potential",
  "Minimal refining severity required",
  "Premium condensate-like crude quality"
]
},

MILLENNIUM: {
  name: "Millennium Crude Oil",
  country: "Nigeria",
  type: "Medium Sweet",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
bulkElementalComposition: {
  1: { name: "Carbon, C", value: "85.0", unit: "wt%" },
  2: { name: "Hydrogen, H", value: "13.0", unit: "wt%" },
  3: { name: "Sulfur, S", value: "0.28", unit: "wt%" },
  4: { name: "Nitrogen, N", value: "0.10", unit: "wt%" },
  5: { name: "Oxygen, O", value: "0.22", unit: "wt%" },
  6: { name: "H/C Ratio", value: "1.83", unit: "" }
},

/* ================= B. PHYSICAL PROPERTIES ================= */
physicalProperties: {
  7: { name: "API Gravity @ 60°F", value: "32", unit: "°API" },
  8: { name: "Specific Gravity @ 60/60°F", value: "0.87", unit: "" },
  9: { name: "Density @ 15°C", value: "875", unit: "kg/m³" },
  10: { name: "Viscosity @ 20°C", value: "9.5", unit: "cSt" },
  11: { name: "Viscosity @ 40°C", value: "5.8", unit: "cSt" },
  12: { name: "Viscosity @ 50°C", value: "3.2–4.2", unit: "cSt" },
  13: { name: "Viscosity @ 100°C", value: "1.6", unit: "cSt" },
  14: { name: "Pour Point", value: "-10 to -20", unit: "°C" },
  15: { name: "Cloud Point", value: "-25", unit: "°C" },
  16: { name: "Flash Point", value: "22", unit: "°C" },
  17: { name: "Fire Point", value: "32", unit: "°C" },
  18: { name: "Reid Vapor Pressure (RVP)", value: "28", unit: "kPa" },
  19: { name: "Salt Content", value: "12", unit: "PTB" },
  20: { name: "Water Content", value: "0.2", unit: "vol%" },
  21: { name: "Sediment Content", value: "0.02", unit: "wt%" },
  22: { name: "BS&W", value: "0.2", unit: "vol%" },
  23: { name: "Ash Content", value: "0.02", unit: "wt%" }
},

/* ================= C. CORROSION & STABILITY ================= */
corrosionStability: {
  24: { name: "Total Acid Number (TAN)", value: "0.30", unit: "mg KOH/g" },
  25: { name: "Strong Acid Number (SAN)", value: "0.01", unit: "mg KOH/g" },
  26: { name: "Mercaptan Sulfur (RSH)", value: "2.5", unit: "mg/kg" },
  27: { name: "H₂S in Liquid", value: "2", unit: "mg/kg" },
  28: { name: "H₂S Vapor Space", value: "15", unit: "ppm" },
  29: { name: "Organic Chlorides", value: "1", unit: "ppm" },
  30: { name: "Inorganic Chlorides", value: "Trace", unit: "mg/kg" }
},

/* ================= D. TRACE METALS ================= */
traceMetals: {
  31: { name: "Nickel (Ni)", value: "6", unit: "ppm" },
  32: { name: "Vanadium (V)", value: "1.5", unit: "ppm" },
  33: { name: "Iron (Fe)", value: "4", unit: "ppm" },
  34: { name: "Sodium (Na)", value: "6", unit: "ppm" },
  35: { name: "Calcium (Ca)", value: "5", unit: "ppm" },
  36: { name: "Magnesium (Mg)", value: "2", unit: "ppm" },
  37: { name: "Copper (Cu)", value: "0.5", unit: "ppm" },
  38: { name: "Lead (Pb)", value: "0.5", unit: "ppm" },
  39: { name: "Zinc (Zn)", value: "1", unit: "ppm" },
  40: { name: "Silicon (Si)", value: "2", unit: "ppm" },
  41: { name: "Phosphorus (P)", value: "1", unit: "ppm" },
  42: { name: "Arsenic (As)", value: "10", unit: "ppb" },
  43: { name: "Mercury (Hg)", value: "5", unit: "ppb" },
  44: { name: "Selenium (Se)", value: "10", unit: "ppb" }
},

/* ================= E. SARA ANALYSIS ================= */
saraAnalysis: {
  45: { name: "Saturates", value: "63", unit: "wt%" },
  46: { name: "Aromatics", value: "27", unit: "wt%" },
  47: { name: "Resins", value: "10", unit: "wt%" },
  48: { name: "Asphaltenes (nC7)", value: "0.25", unit: "wt%" },
  49: { name: "Asphaltenes (nC5)", value: "0.6", unit: "wt%" },
  50: { name: "Wax Content", value: "16", unit: "wt%" }
},

/* ================= F. LIGHT ENDS ================= */
lightEnds: {
  51: { name: "Methane (C1)", value: "0.02", unit: "wt%" },
  52: { name: "Ethane (C2)", value: "0.02", unit: "wt%" },
  53: { name: "Propane (C3)", value: "0.18", unit: "wt%" },
  54: { name: "i-Butane", value: "0.25", unit: "wt%" },
  55: { name: "n-Butane", value: "0.55", unit: "wt%" },
  56: { name: "i-Pentane", value: "0.9", unit: "wt%" },
  57: { name: "n-Pentane", value: "1.1", unit: "wt%" },
  58: { name: "Cyclopentane", value: "0.2", unit: "wt%" },
  59: { name: "C6 Hydrocarbons", value: "3.2", unit: "wt%" },
  60: { name: "C7 Hydrocarbons", value: "3.8", unit: "wt%" },
  61: { name: "C8 Hydrocarbons", value: "4.2", unit: "wt%" },
  62: { name: "C9 Hydrocarbons", value: "3.9", unit: "wt%" },
  63: { name: "C10 Hydrocarbons", value: "3.4", unit: "wt%" },
  64: { name: "Benzene", value: "0.15", unit: "vol%" },
  65: { name: "Toluene", value: "0.5", unit: "wt%" },
  66: { name: "Ethylbenzene", value: "130", unit: "ppm" },
  67: { name: "Xylenes", value: "0.35", unit: "wt%" },
  68: { name: "CO₂", value: "0.1", unit: "wt%" },
  69: { name: "N₂", value: "0.05", unit: "wt%" }
},

/* ================= G. TBP DISTILLATION ================= */
tbpDistillation: {
  70: { name: "IBP", value: "16", unit: "°C" },
  71: { name: "5% recovered", value: "52", unit: "°C" },
  72: { name: "10% recovered", value: "85 / 10", unit: "°C / vol%" },
  73: { name: "20% recovered", value: "1155 / 24", unit: "°C / vol%" },
  74: { name: "30% recovered", value: "180 / 29", unit: "°C / vol%" },
  75: { name: "40% recovered", value: "235 / ~40", unit: "°C / vol%" },
  76: { name: "50% recovered", value: "285", unit: "°C" },
  77: { name: "60% recovered", value: "330 / ~64", unit: "°C / vol%" },
  78: { name: "70% recovered", value: "355 / ~69", unit: "°C / vol%" },
  79: { name: "80% recovered", value: "380 / ~74", unit: "°C / vol%" },
  80: { name: "90% recovered", value: "555 / ~93", unit: "°C / vol%" },
  81: { name: "95% recovered", value: "570 / ~95", unit: "°C / vol%" },
  82: { name: "FBP", value: ">565", unit: "°C" },
  83: { name: "% recovered @ 360°C", value: "73", unit: "vol%" },
  84: { name: "% recovered @ 540°C", value: "92", unit: "vol%" }
},

/* ================= H. CUT YIELDS ================= */
cutYields: {
  LPG: {
    wt: { value: 1.30, unit: "wt%" },
    vol: { value: 2.00, unit: "vol%" }
  },

  LightNaphtha: {
    wt: { value: 4.80, unit: "wt%" },
    vol: { value: 6.00, unit: "vol%" },
    density: { value: 650, unit: "kg/m³" },
    RON: { value: 76, unit: "" }
  },

  HeavyNaphtha: {
    wt: { value: 17.0, unit: "wt%" },
    vol: { value: 19.0, unit: "vol%" },
    density: { value: 760, unit: "kg/m³" }
  },

  Kerosene: {
    wt: { value: 15.0, unit: "wt%" },
    vol: { value: 15.5, unit: "vol%" },
    smokePt: { value: 21, unit: "mm" }
  },

  Diesel: {
    wt: { value: 34.0, unit: "wt%" },
    vol: { value: 33.5, unit: "vol%" },
    cetane: { value: 46, unit: "" }
  },

  VGO: {
    wt: { value: 21.0, unit: "wt%" },
    vol: { value: 19.0, unit: "vol%" }
  },

  Residue: {
    wt: { value: 10.0, unit: "wt%" },
    vol: { value: 8.5, unit: "vol%" }
  }
},

/* ================= I. RESIDUE PROPERTIES ================= */
residueProperties: {
  99: { name: "CCR", value: "1.5", unit: "wt%" },
  100: { name: "MCR", value: "variable", unit: "" },
  101: { name: "Ramsbottom Carbon", value: "moderate", unit: "" },
  102: { name: "Asphaltene Stability", value: "5.2", unit: "" },
  103: { name: "Heptane Insolubles", value: "0.25", unit: "wt%" },
  104: { name: "Toluene Insolubles", value: "0.05", unit: "wt%" },
  105: { name: "UOP K Factor", value: "11.75", unit: "" },
  106: { name: "Characterization Factor", value: "11.8", unit: "" }
},

/* ================= KEY POINTS ================= */
keyPoints: [
  "Medium sweet Nigerian crude",
  "Balanced gasoline/diesel yield",
  "Moderate wax content",
  "Slightly higher TAN than Bonny Light",
  "Stable refinery feedstock"
]
},


INGENTIA: {
  name: "Ingentia Crude Oil",
  country: "Nigeria",
  type: "Medium Light Sweet",


  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
  bulkElementalComposition: {
    1: { name: "Carbon, C", value: 85.8, unit: "wt%" },
    2: { name: "Hydrogen, H", value: 13.2, unit: "wt%" },
    3: { name: "Sulfur, S", valueMin: 0.12, valueMax: 0.18, unit: "wt%" },
    4: { name: "Nitrogen, N", valueMin: 0.07, valueMax: 0.09, unit: "wt%" },
    5: { name: "Oxygen, O", value: 0.20, unit: "wt%" },
    6: { name: "H/C Ratio", value: 1.85, unit: "dimensionless" }
  },

  /* ================= B. PHYSICAL PROPERTIES ================= */
  physicalProperties: {
    7: { name: "API Gravity @ 60°F", valueMin: 33, valueMax: 36, unit: "°API" },
    8: { name: "Specific Gravity @ 60/60°F", value: 0.85, unit: "–" },
    9: { name: "Density @ 15°C", valueMin: 845, valueMax: 855, unit: "kg/m³" },
    10: { name: "Viscosity @ 20°C", valueMin: 7.5, valueMax: 9.0, unit: "cSt" },
    11: { name: "Viscosity @ 40°C", valueMin: 4.5, valueMax: 5.5, unit: "cSt" },
    12: { name: "Viscosity @ 50°C", valueMin: 2.8, valueMax: 3.6, unit: "cSt" },
    13: { name: "Viscosity @ 100°C", valueMin: 1.4, valueMax: 1.6, unit: "cSt" },
    14: { name: "Pour Point", valueMin: -28, valueMax: -15, unit: "°C" },
    15: { name: "Cloud Point", value: -30, unit: "°C" },
    16: { name: "Flash Point", value: 21, unit: "°C (max)" },
    17: { name: "Fire Point", valueMin: 29, valueMax: 33, unit: "°C" },
    18: { name: "Reid Vapor Pressure (RVP)", valueMin: 24, valueMax: 27, unit: "kPa" },
    19: { name: "Salt Content", value: 10, unit: "PTB (max)" },
    20: { name: "Water Content", value: 0.1, unit: "vol% (max)" },
    21: { name: "Sediment Content", value: 0.01, unit: "wt% (max)" },
    22: { name: "BS&W", value: 0.1, unit: "vol% (max)" },
    23: { name: "Ash Content", value: 0.01, unit: "wt%" }
  },

  /* ================= C. CORROSION & STABILITY ================= */
  corrosionStability: {
    24: { name: "Total Acid Number (TAN)", valueMin: 0.15, valueMax: 0.22, unit: "mg KOH/g" },
    25: { name: "Strong Acid Number (SAN)", value: 0.01, unit: "mg KOH/g (max)" },
    26: { name: "Mercaptan Sulfur", value: 1.8, unit: "mg/kg" },
    27: { name: "H₂S in Liquid", value: 1, unit: "mg/kg (max)" },
    28: { name: "H₂S Vapor Space", valueMin: 8, valueMax: 12, unit: "ppm" },
    29: { name: "Organic Chlorides", value: 1, unit: "ppm (max)" },
    30: { name: "Inorganic Chlorides", value: "trace", unit: "mg/kg" }
  },

  /* ================= D. TRACE METALS ================= */
  traceMetals: {
    31: { name: "Nickel (Ni)", valueMin: 2.5, valueMax: 4, unit: "ppm" },
    32: { name: "Vanadium (V)", valueMin: 0.2, valueMax: 0.6, unit: "ppm" },
    33: { name: "Iron (Fe)", valueMin: 1, valueMax: 3, unit: "ppm" },
    34: { name: "Sodium (Na)", valueMin: 1, valueMax: 4, unit: "ppm" },
    35: { name: "Calcium (Ca)", value: 5, unit: "ppm (max)" },
    36: { name: "Magnesium (Mg)", value: 1, unit: "ppm (max)" },
    37: { name: "Copper (Cu)", value: 0.5, unit: "ppm (max)" },
    38: { name: "Lead (Pb)", value: 0.5, unit: "ppm (max)" },
    39: { name: "Zinc (Zn)", value: 1, unit: "ppm (max)" },
    40: { name: "Silicon (Si)", value: 2, unit: "ppm (max)" },
    41: { name: "Phosphorus (P)", value: 1, unit: "ppm (max)" },
    42: { name: "Arsenic (As)", value: 10, unit: "ppb (max)" },
    43: { name: "Mercury (Hg)", value: 5, unit: "ppb (max)" },
    44: { name: "Selenium (Se)", value: 10, unit: "ppb (max)" }
  },

  /* ================= E. SARA ANALYSIS ================= */
  saraAnalysis: {
    45: { name: "Saturates", value: 64, unit: "wt%" },
    46: { name: "Aromatics", value: 26, unit: "wt%" },
    47: { name: "Resins", valueMin: 8, valueMax: 9, unit: "wt%" },
    48: { name: "Asphaltenes (nC7)", valueMin: 0.04, valueMax: 0.18, unit: "wt%" },
    49: { name: "Asphaltenes (nC5)", valueMin: 0.40, valueMax: 0.55, unit: "wt%" },
    50: { name: "Wax Content", valueMin: 14, valueMax: 16, unit: "wt%" }
  },

  /* ================= F. LIGHT ENDS ================= */
  lightEnds: {
    51: { name: "Methane (C1)", value: 0.02, unit: "wt%" },
    52: { name: "Ethane (C2)", value: 0.02, unit: "wt%" },
    53: { name: "Propane (C3)", value: 0.19, unit: "wt%" },
    54: { name: "i-Butane", value: 0.26, unit: "wt%" },
    55: { name: "n-Butane", value: 0.58, unit: "wt%" },
    56: { name: "i-Pentane", value: 0.95, unit: "wt%" },
    57: { name: "n-Pentane", value: 1.10, unit: "wt%" },
    58: { name: "Cyclopentane", value: 0.20, unit: "wt%" },
    59: { name: "C6 Hydrocarbons", value: 3.3, unit: "wt%" },
    60: { name: "C7 Hydrocarbons", value: 3.9, unit: "wt%" },
    61: { name: "C8 Hydrocarbons", value: 4.3, unit: "wt%" },
    62: { name: "C9 Hydrocarbons", value: 3.8, unit: "wt%" },
    63: { name: "C10 Hydrocarbons", value: 3.4, unit: "wt%" },
    64: { name: "Benzene", value: 0.18, unit: "vol%" },
    65: { name: "Toluene", value: 0.52, unit: "wt%" },
    66: { name: "Ethylbenzene", value: 135, unit: "ppm" },
    67: { name: "Xylenes", value: 0.36, unit: "wt%" },
    68: { name: "CO₂", value: 0.1, unit: "wt% (max)" },
    69: { name: "N₂", value: 0.05, unit: "wt% (max)" }
  },

  /* ================= G. TBP DISTILLATION ================= */
  tbpDistillation: {
    70: { name: "IBP", valueMin: -10, valueMax: 5, unit: "°C" },
    71: { name: "5% recovered", value: 40, unit: "°C" },
    72: { name: "10% recovered", value: 70, unit: "°C" },
    73: { name: "20% recovered", value: 120, unit: "°C" },
    74: { name: "30% recovered", value: 180, unit: "°C" },
    75: { name: "40% recovered", value: 240, unit: "°C" },
    76: { name: "50% recovered", value: 300, unit: "°C" },
    77: { name: "60% recovered", value: 360, unit: "°C" },
    78: { name: "70% recovered", value: 420, unit: "°C" },
    79: { name: "80% recovered", value: 480, unit: "°C" },
    80: { name: "90% recovered", value: 520, unit: "°C" },
    81: { name: "95% recovered", value: 550, unit: "°C" },
    82: { name: "FBP", value: 550, unit: "°C (min)" }
  },

  /* ================= H. CUT YIELDS ================= */
  cutYields: {
    LPG: { wt: 1.28, vol: 1.95, unit: "wt%, vol%" },
    LightNaphtha: { wt: 4.70, vol: 5.90, density: 645, RON: 75 },
    HeavyNaphtha: { wt: 16.8, vol: 18.7, density: 755 },
    Kerosene: { wt: 14.8, vol: 15.2, smokePt: 22 },
    Diesel: { wt: 33.8, vol: 33.2, cetane: 45 },
    VGO: { wt: 21.5, vol: 19.3 },
    Residue: { wt: 10.2, vol: 8.7 }
  },

  /* ================= I. RESIDUE PROPERTIES ================= */
  residueProperties: {
    99: { name: "CCR", valueMin: 1.3, valueMax: 1.6, unit: "wt%" },
    100: { name: "MCR", value: "variable", unit: null },
    101: { name: "Ramsbottom Carbon", value: "moderate", unit: null },
    102: { name: "Asphaltene Stability", valueMin: 4.9, valueMax: 5.3, unit: null },
    103: { name: "Heptane Insolubles", valueMin: 0.16, valueMax: 0.24, unit: "wt%" },
    104: { name: "Toluene Insolubles", value: 0.05, unit: "wt% (max)" },
    105: { name: "UOP K Factor", valueMin: 11.65, valueMax: 11.78, unit: null },
    106: { name: "Characterization Factor", valueMin: 11.7, valueMax: 11.85, unit: null }
  },

  /* ================= KEY POINTS ================= */
  keyPoints: [
    "Medium light sweet Nigerian crude",
    "Good diesel yield profile",
    "Low to moderate sulfur",
    "Stable refinery feedstock",
    "High operational flexibility"
  ]
},


PAN_OCEAN_CONDENSATE: {
  name: "Pan Ocean Condensate",
  country: "Nigeria",
  type: "Ultra Light Sweet Condensate",

  /* ================= A. BULK ELEMENTAL COMPOSITION ================= */
  bulkElementalComposition: {
    1: { name: "Carbon, C", value: 85.8, unit: "wt%" },
    2: { name: "Hydrogen, H", value: 13.2, unit: "wt%" },
    3: { name: "Sulfur, S", value: "0.12", unit: "wt%" },
    4: { name: "Nitrogen, N", value: "0.07", unit: "wt%" },
    5: { name: "Oxygen, O", value: 0.20, unit: "wt%" },
    6: { name: "H/C Ratio", value: 1.85, unit: "dimensionless" }
  },

  /* ================= B. PHYSICAL PROPERTIES ================= */
  physicalProperties: {
    7: { name: "API Gravity @ 60°F", value: "36", unit: "°API" },
    8: { name: "Specific Gravity @ 60/60°F", value: 0.85, unit: "–" },
    9: { name: "Density @ 15°C", value: "855", unit: "kg/m³" },
    10: { name: "Viscosity @ 20°C", value: "9.0", unit: "cSt" },
    11: { name: "Viscosity @ 40°C", value: "5.5", unit: "cSt" },
    12: { name: "Viscosity @ 50°C", value: "3.6", unit: "cSt" },
    13: { name: "Viscosity @ 100°C", value: "1.6", unit: "cSt" },
    14: { name: "Pour Point", value: "-15 to -28", unit: "°C" },
    15: { name: "Cloud Point", value: -30, unit: "°C" },
    16: { name: "Flash Point", value: "<21", unit: "°C" },
    17: { name: "Fire Point", value: "33", unit: "°C" },
    18: { name: "Reid Vapor Pressure (RVP)", value: "27", unit: "kPa" },
    19: { name: "Salt Content", value: "<10", unit: "PTB" },
    20: { name: "Water Content", value: "<0.1", unit: "vol%" },
    21: { name: "Sediment Content", value: "<0.01", unit: "wt%" },
    22: { name: "BS&W", value: "<0.1", unit: "vol%" },
    23: { name: "Ash Content", value: 0.01, unit: "wt%" }
  },

  /* ================= C. CORROSION & STABILITY ================= */
  corrosionStability: {
    24: { name: "Total Acid Number (TAN)", value: "0.22", unit: "mg KOH/g" },
    25: { name: "Strong Acid Number (SAN)", value: "<0.01", unit: "mg KOH/g" },
    26: { name: "Mercaptan Sulfur", value: 1.8, unit: "mg/kg" },
    27: { name: "H₂S in Liquid", value: "<1", unit: "mg/kg" },
    28: { name: "H₂S Vapor Space", value: "12", unit: "ppm" },
    29: { name: "Organic Chlorides", value: "<1", unit: "ppm" },
    30: { name: "Inorganic Chlorides", value: "trace", unit: "mg/kg" }
  },

  /* ================= D. TRACE METALS ================= */
  traceMetals: {
    31: { name: "Nickel (Ni)", value: "4", unit: "ppm" },
    32: { name: "Vanadium (V)", value: "0.6", unit: "ppm" },
    33: { name: "Iron (Fe)", value: "3", unit: "ppm" },
    34: { name: "Sodium (Na)", value: "4", unit: "ppm" },
    35: { name: "Calcium (Ca)", value: "<5", unit: "ppm" },
    36: { name: "Magnesium (Mg)", value: "<1", unit: "ppm" },
    37: { name: "Copper (Cu)", value: "<0.5", unit: "ppm" },
    38: { name: "Lead (Pb)", value: "<0.5", unit: "ppm" },
    39: { name: "Zinc (Zn)", value: "<1", unit: "ppm" },
    40: { name: "Silicon (Si)", value: "<2", unit: "ppm" },
    41: { name: "Phosphorus (P)", value: "<1", unit: "ppm" },
    42: { name: "Arsenic (As)", value: "<10", unit: "ppb" },
    43: { name: "Mercury (Hg)", value: "<5", unit: "ppb" },
    44: { name: "Selenium (Se)", value: "<10", unit: "ppb" }
  },

  /* ================= E. SARA ANALYSIS ================= */
  saraAnalysis: {
    45: { name: "Saturates", value: 64, unit: "wt%" },
    46: { name: "Aromatics", value: 26, unit: "wt%" },
    47: { name: "Resins", value: "9", unit: "wt%" },
    48: { name: "Asphaltenes (nC7)", value: "0.18", unit: "wt%" },
    49: { name: "Asphaltenes (nC5)", value: "0.55", unit: "wt%" },
    50: { name: "Wax Content", value: "16", unit: "wt%" }
  },

  /* ================= F. LIGHT ENDS ================= */
  lightEnds: {
    51: { name: "Methane (C1)", value: 0.02, unit: "wt%" },
    52: { name: "Ethane (C2)", value: 0.02, unit: "wt%" },
    53: { name: "Propane (C3)", value: 0.19, unit: "wt%" },
    54: { name: "i-Butane", value: 0.26, unit: "wt%" },
    55: { name: "n-Butane", value: 0.58, unit: "wt%" },
    56: { name: "i-Pentane", value: 0.95, unit: "wt%" },
    57: { name: "n-Pentane", value: 1.10, unit: "wt%" },
    58: { name: "Cyclopentane", value: 0.20, unit: "wt%" },
    59: { name: "C6 Hydrocarbons", value: 3.3, unit: "wt%" },
    60: { name: "C7 Hydrocarbons", value: 3.9, unit: "wt%" },
    61: { name: "C8 Hydrocarbons", value: 4.3, unit: "wt%" },
    62: { name: "C9 Hydrocarbons", value: 3.8, unit: "wt%" },
    63: { name: "C10 Hydrocarbons", value: 3.4, unit: "wt%" },
    64: { name: "Benzene", value: 0.18, unit: "vol%" },
    65: { name: "Toluene", value: 0.52, unit: "wt%" },
    66: { name: "Ethylbenzene", value: 135, unit: "ppm" },
    67: { name: "Xylenes", value: 0.36, unit: "wt%" },
    68: { name: "CO₂", value: "<0.1", unit: "wt%" },
    69: { name: "N₂", value: "<0.05", unit: "wt%" }
  },

  /* ================= G. TBP DISTILLATION ================= */
  tbpDistillation: {
    70: { name: "IBP", value: "16", unit: "°C" },
    71: { name: "5% recovered", value: "50", unit: "°C" },
    72: { name: "10% recovered", value: "82", unit: "°C" },
    73: { name: "20% recovered", value: "150", unit: "°C" },
    74: { name: "30% recovered", value: "180", unit: "°C" },
    75: { name: "40% recovered", value: "235", unit: "°C" },
    76: { name: "50% recovered", value: "280", unit: "°C" },
    77: { name: "60% recovered", value: "325", unit: "°C" },
    78: { name: "70% recovered", value: "350", unit: "°C" },
    79: { name: "80% recovered", value: "375", unit: "°C" },
    80: { name: "90% recovered", value: "550", unit: "°C" },
    81: { name: "95% recovered", value: "565", unit: "°C" },
    82: { name: "FBP", value: ">565", unit: "°C" }
  },

  /* ================= H. CUT YIELDS ================= */
  cutYields: {
    LPG: { wt: 1.28, vol: 1.95, unit: "wt%, vol%" },
    LightNaphtha: { wt: 4.70, vol: 5.90, density: 645, RON: 75 },
    HeavyNaphtha: { wt: 16.8, vol: 18.7, density: 755 },
    Kerosene: { wt: 14.8, vol: 15.2, smokePt: 22 },
    Diesel: { wt: 33.8, vol: 33.2, cetane: 45 },
    VGO: { wt: 21.5, vol: 19.3 },
    Residue: { wt: 10.2, vol: 8.7 }
  },

  /* ================= I. RESIDUE PROPERTIES ================= */
  residueProperties: {
    99: { name: "CCR", value: 1.6, unit: "wt%" },
    100: { name: "MCR", value: "variable", unit: null },
    101: { name: "Ramsbottom Carbon", value: "moderate", unit: null },
    102: { name: "Asphaltene Stability", value: "5.3", unit: null },
    103: { name: "Heptane Insolubles", value: "0.24", unit: "wt%" },
    104: { name: "Toluene Insolubles", value: "<0.05", unit: "wt%" },
    105: { name: "UOP K Factor", value: "11.78", unit: null },
    106: { name: "Characterization Factor", value: "11.85", unit: null }
  },

  /* ================= KEY POINTS ================= */
  keyPoints: [
    "Medium light sweet Nigerian crude",
    "Good diesel yield profile",
    "Low to moderate sulfur",
    "Stable refinery feedstock",
    "High operational flexibility"
  ]
}

};


